// @ts-nocheck
import axios from "axios"
import endpoints from '../../config/endpoints.config'

const updateUser = async (username: string, attributes: any) => {
    return await axios.put(endpoints.auth.updateUser, {
        username,
        attributes
    })
}

export default updateUser